import createLucideIcon from '../createLucideIcon';

const Wand2 = createLucideIcon('Wand2Icon', [
  [
    'path',
    {
      d: 'm21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72Z',
      key: '1bcowg',
    },
  ],
  ['path', { d: 'm14 7 3 3', key: '1r5n42' }],
  ['path', { d: 'M5 6v4', key: 'ilb8ba' }],
  ['path', { d: 'M19 14v4', key: 'blhpug' }],
  ['path', { d: 'M10 2v2', key: '7u0qdc' }],
  ['path', { d: 'M7 8H3', key: 'zfb6yr' }],
  ['path', { d: 'M21 16h-4', key: '1cnmox' }],
  ['path', { d: 'M11 3H9', key: '1obp7u' }],
]);

export default Wand2;
